// src/services/redux/api/endpoints/general/gicPolicyReportEndpoints.js
export const gicPolicyReportEndpoints = (builder) => ({
  // GET paginated GIC policy report data
  getGICPolicyReport: builder.query({
    query: (args = {}) => ({
      url: '/GeneralInsurance/generate-gic-policy-report',
      method: 'GET',
      params: args,
    }),
    transformResponse: (response) => ({
      data: response?.data ?? [],
      totalCount: response?.totalCount ?? 0,
      success: !!response?.success,
      message: response?.message ?? '',
    }),
    providesTags: [{ type: 'GICPolicyReport', id: 'LIST' }],
  }),

  // LAZY preview PDF
  previewGICPolicyReport: builder.query({
    query: (params = {}) => ({
      url: '/GeneralInsurance/preview-gic-policy-report',
      method: 'GET',
      params,
    }),
    transformResponse: (response) => response,
    providesTags: [{ type: 'GICPolicyReport', id: 'PREVIEW' }],
  }),

  // EXPORT job (returns jobId)
  exportGICPolicyReport: builder.mutation({
    query: (params = {}) => ({
      url: '/GeneralInsurance/export-gic-policy-report',
      method: 'GET',
      params,
    }),
    transformResponse: (response) => response,
  }),

  // Export job status
  getGICExportStatus: builder.query({
    query: (jobId) => ({
      url: `/GeneralInsurance/gic-export-status/${jobId}`,
      method: 'GET',
    }),
    transformResponse: (response) => response,
  }),
});
